/**
 * B_Sprite.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.02.26
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Util  from 'canvas/base/dev/util/B_Util';
import B_Define from 'canvas/base/dev/util/B_Define';

const B_Sprite = (function(superclass){

	// [V]
	const $ = {
		_sprite : null
	};

	return class extends superclass {

		constructor(obj) {
	        super(obj);

			// [E] obj.res
			if(obj.res == undefined) {
				B_Util.print("[코드모스] => 요청하신 " + obj.id+ " 이미지 객체의 Resource가 없습니다. ");
				return;
			}

			// [E] obj.sprite
			if(!this.CODMOS._res[obj.res].sprite) {
				B_Util.print("[코드모스] => Image Sprite 객체에 Sprite 좌표 정보가 없습니다.");
				return;
			}

			// [S] strResType, object
			this._strResType = B_Define.ARR_RES_TYPE[1];
			this._object = new createjs.Bitmap(this.CODMOS._res[obj.res].result);
			this._container.addChild(this._object);

			// [S] sprite
			this._sprite = this.CODMOS._res[obj.res].sprite;
			this._object.sourceRect = new createjs.Rectangle(
				parseInt(this._sprite.x),
				parseInt(this._sprite.y),
				parseInt(this._sprite.w),
				parseInt(this._sprite.h));
		}

		// [V]

		get _sprite () { return $._sprite; }
		set _sprite (s) {
			if(
				typeof s != 'object'
				||
				typeof s.x != 'number'
				||
				typeof s.y != 'number'
				||
				typeof s.w != 'number'
				||
				typeof s.h != 'number'
			) {
				B_Util.print('[코드모스] => ' + this._id + ' 객체의 sprite 정보가 올바르지 않습니다. sprite를 확인해주세요.');
				return;
			}
			$._sprite = JSON.parse(JSON.stringify(s));
		}

		// [F]

		// @OVERRIDING
		_setArea(w, h) {
			if(super._checkArea(w,h)) {
				this._object.scaleX = this._w / this._sprite.w;
				this._object.scaleY = this._h / this._sprite.h;
			}
		}

		// @OVERRIDING
		_setPoint(px, py) {
			if(super._checkReg(px, py)) {
				this._object.regX = this._w / this._object.scaleX * this._pointX / 100;
				this._object.regY = this._h / this._object.scaleY * this._pointY / 100;
			}
		}

		// @OVERRIDING
		_getOriginWidth() { return this._sprite.w; }

		// @OVERRIDING
		_getOriginHeight() { return this._sprite.h; }

	}
});

export default B_Sprite;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/sprite/B_Sprite.js